import PropTypes from 'prop-types';

import Button from '@mui/material/Button';

import classes from './AcademyMenuMovil.module.css';

const AcademyMenuMovil = props => {
  return props.menu.map(item => (
    <li className={classes.itemMenu} key={item.id}>
      <Button
        className={classes.itemLink}
        component="a"
        href={item.url}
      >
        {item.menuName}
      </Button>
    </li>
  ));
};

AcademyMenuMovil.propTypes = {
  // eslint-disable-next-line react/require-default-props
  menu: PropTypes.array
};

export default AcademyMenuMovil;
